module.exports = __webpack_public_path__ + "static/media/Doris M.580474c2.jpg";